import {PlayerReduxState} from "../types";
import {ChallengeMode} from "../../../schema";

export default function isExamStage(state: PlayerReduxState) {
  switch (state.challenge.mode) {
    case ChallengeMode.COMPETENCE_TEST:
    case ChallengeMode.CHOICE_BASED_STUDY:
    case ChallengeMode.CHOICES_WITH_CUSTOM_SCORES:
    case ChallengeMode.CUSTOM_PARAMETERS_TEST:
    case ChallengeMode.RPG_MODE:
      return state.level === 1;
    default:
      console.warn("isExam: unsupported challenge mode " + state.challenge.mode)
      return false;
  }
}
